module.exports = __webpack_public_path__ + "static/media/stephanie-krist.4dd6b5d1.jpg";